
$(function () {

    // Lens Circle Demo - Cycles through classnames for CSS transitions to take effect
    var lensCircleDemo = function() {
        var imageCircles = ['oneInch', 'twoThirdsInch', 'oneHalfInch']
        var i = 0

        setInterval(function() {
            $('#lens-circle-demo').attr('class', imageCircles[++i % imageCircles.length])
        }, 3000)
    }
    lensCircleDemo()


    // Aim Assist Demo
    var aimAssistDemo = function() {
        $('#aim-assist-button, #aim-assist-link').click(function() {
            event.preventDefault()
            $('#aim-assist').toggleClass('aim-assist-on')
        })
    }
    aimAssistDemo()


    // Update product prices
    var updateProductPrices = function(elem) {
        $(elem).each(function() {
            var productBasePrice    = Number( $(this).find('[name="baseprice"]').attr('value') )
            var productOptionPrices = 0
            var productTotalPrice   = 0

            $(this).find('input:checked').each(function() {
                var productOptionPrice = Number( $(this).siblings('label').find('[data-option-price]').attr('data-option-price') )

                // Make sure value is a number
                productOptionPrice = +productOptionPrice || 0

                // Add option price to options total
                productOptionPrices = productOptionPrices + productOptionPrice
            })

            // Add option prices to base price
            productTotalPrice = productBasePrice + productOptionPrices

            // Update displayed product price
            $(this).find('.price').text(productTotalPrice).formatCurrency({ roundToDecimalPlace: 0 })
        })
    }
    updateProductPrices( $('.product') )


    // Update product option prices
    var updateProductOptionPrices = function(elem) {
        $(elem).each(function() {
            var productBasePrice    = Number( $(this).find('[name="baseprice"]').attr('value') )
            var productCurrentPrice = $(this).find('.price').asNumber()

            // Clear out the current values
            $(this).find('[data-option-price]').each(function() {
                $(this).empty()
            })

            // Find option group (i.e. Lens, Lens Mount)
            $(this).find('.option').each(function() {
                var selectedOption      = $(this).find('input:checked')
                var selectedOptionPrice = Number( selectedOption.siblings('label').find('[data-option-price]').attr('data-option-price') )

                // Make sure value is a number
                selectedOptionPrice = +selectedOptionPrice || 0

                // Find unselected radio options
                selectedOption.closest('li').siblings().each(function() {
                    var unselectedOption = $(this).find('[data-option-price]')
                    var unselectedOptionPrice = Number( unselectedOption.attr('data-option-price') )
                    var priceDifference

                    // Make sure value is a number
                    unselectedOptionPrice = +unselectedOptionPrice || 0

                    // Calculate price difference between ooptions
                    priceDifference = selectedOptionPrice - unselectedOptionPrice

                    // Update displayed option prices
                    if (priceDifference < 0) {
                        priceDifference = Math.abs(priceDifference)
                        $(this).find('[data-option-price]').text('+ $' + priceDifference)
                    }
                    else if (priceDifference === 0) {
                        $(this).find('[data-option-price]').text('')
                    }
                    else {
                        $(this).find('[data-option-price]').text('- $' + priceDifference)
                    }
                })
            })
        })
    }
    updateProductOptionPrices( $('.product') )


    // When product options change...
    $('.optionset').change(function() {
        updateProductPrices( $('.product') )
        updateProductOptionPrices( $('.product') )
    })
});

// On load...
$(window).on('load', function() {

    // Add classname to body for CSS page load transtions
    $('html').addClass('page-loaded')

    // Play intro video
    if ( $('#prime-color-overview').length === 1 ) {
        document.getElementById('ink-flow').play()
    }
});

/* lightbox */
$(document).ready(function() {
    $('.lightbox-single-light').magnificPopup({type:'image', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade lightTheme'});

});
